import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, MapPin, Bell, Users, ShieldCheck, Sparkles, LogOut, ChevronRight, Trophy } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { Page } from "@/components/shared";

export default function More() {
  const nav = useNavigate();
  const { user, logout } = useAuth();
  const [loc, setLoc] = useState(true);
  const [crewShare, setCrewShare] = useState(true);
  const [comms, setComms] = useState(true);

  const links = [
    { icon: ShieldCheck, label: "Safety Passport", to: "/app/passport" },
    { icon: Trophy, label: "My Impact", to: "/app/impact" },
    { icon: MapPin, label: "Safe Points", to: "/app/safe-points" },
  ];

  const toggles = [
    { label: "Location permissions", val: loc, set: setLoc, sub: "Allow temporary location sharing", t: "location" },
    { label: "Crew sharing", val: crewShare, set: setCrewShare, sub: "Let your crew see your check-ins", t: "crew" },
    { label: "Communications", val: comms, set: setComms, sub: "Receive band updates & alerts", t: "comms" },
  ];

  return (
    <Page className="px-5 pt-6">
      <button data-testid="more-back" onClick={() => nav("/app")} className="cs-tap flex items-center gap-1 text-sm mb-4" style={{ color: "var(--cs-fg2)" }}>
        <ArrowLeft size={18} /> Home
      </button>
      <h1 className="font-head font-extrabold text-3xl">More</h1>

      <div className="cs-card mt-5 p-4 flex items-center gap-3">
        <span className="grid place-items-center rounded-full font-bold" style={{ width: 48, height: 48, background: "var(--cs-card-hi)", color: "var(--cs-magenta)" }}>
          {(user?.name || "U").split(" ").map((x) => x[0]).slice(0, 2).join("")}
        </span>
        <div>
          <p className="font-head font-bold text-lg leading-none">{user?.name}</p>
          <p className="text-xs mt-1" style={{ color: "var(--cs-fg2)" }}>{user?.email}</p>
        </div>
      </div>

      <div className="mt-4 space-y-2">
        {links.map((l) => (
          <button key={l.label} data-testid={`more-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`} onClick={() => nav(l.to)}
            className="cs-card cs-tap w-full p-4 flex items-center justify-between">
            <span className="flex items-center gap-3"><l.icon size={20} style={{ color: "var(--cs-magenta)" }} /> <span className="font-semibold">{l.label}</span></span>
            <ChevronRight size={18} style={{ color: "var(--cs-fg2)" }} />
          </button>
        ))}
      </div>

      <p className="text-xs font-bold tracking-wide mt-6 mb-2" style={{ color: "var(--cs-fg2)" }}>PRIVACY & LOCATION CONTROLS</p>
      <div className="cs-card p-1">
        {toggles.map((tg, i) => (
          <div key={tg.t} data-testid={`more-toggle-${tg.t}`} className="flex items-center justify-between p-3" style={{ borderBottom: i < toggles.length - 1 ? "1px solid var(--cs-border)" : "none" }}>
            <div>
              <p className="font-semibold text-sm">{tg.label}</p>
              <p className="text-xs" style={{ color: "var(--cs-fg2)" }}>{tg.sub}</p>
            </div>
            <button onClick={() => tg.set(!tg.val)} className="cs-tap rounded-full transition-colors" style={{ width: 48, height: 28, background: tg.val ? "var(--cs-green)" : "var(--cs-border)", position: "relative" }}>
              <span className="absolute rounded-full bg-white transition-all" style={{ width: 22, height: 22, top: 3, left: tg.val ? 23 : 3 }} />
            </button>
          </div>
        ))}
      </div>
      <p className="text-xs mt-3 px-1" style={{ color: "#52525b" }}>
        Location sharing is always opt-in, temporary and revocable. We never track you in the background, never sell your data, and never use help events for advertising.
      </p>

      <button data-testid="more-logout" onClick={() => { logout(); toast.success("Signed out"); nav("/"); }}
        className="cs-tap w-full mt-6 mb-2 rounded-2xl flex items-center justify-center gap-2 font-semibold" style={{ height: 52, background: "var(--cs-card)", border: "1px solid var(--cs-border)", color: "var(--cs-red)" }}>
        <LogOut size={18} /> Sign out
      </button>
    </Page>
  );
}
